import * as angular from "angular";

/**
 * AV-17963: placeholder for the Live activity page. Real map and session
 * list come in a later ticket; this only reserves the route and sidebar slot.
 */
let AdminLiveComponent = {
    selector: "vcAdminLive",
    templateUrl: "/angular/components/admin/admin-live.component.html",
    bindings: {},
    controller: class AdminLiveController {},
};

angular
    .module("admin")
    .component(AdminLiveComponent.selector, AdminLiveComponent);
